export default "__VITE_ASSET__B7c4IJBO__"